import { startCase } from 'lodash'

import { canReorder, isAlwaysPinned, isColumnConfigurable } from '@Components/ColumnsConfig/config'

export { DEFAULT_COLUMNS_CONFIG, isColumnConfigurable, resolvePinned, applyColumnsConfig, togglePinColumn, hideColumn, reorderColumnsConfig } from '@Components/ColumnsConfig/config'

export function withGroupColumnDefaults(columns = []) {
  if (!columns.length) {
    return columns
  }

  const [group, ...rest] = columns
  return [{ alwaysPin: true, allowReorder: false, ...group }, ...rest]
}

export function buildColumnsCatalog({ columns = [], metricColumns, metricOptions = [] }) {
  if (!columns.length) {
    return []
  }

  const known = new Set(columns.map(({ dataField }) => dataField))
  const metricKeys = new Set(metricOptions.map(({ value }) => value))
  const available = metricColumns ?? metricOptions.map(({ value, label }) => ({ dataField: value, text: label }))
  const extras = available.filter(({ dataField }) => !known.has(dataField) && metricKeys.has(dataField))

  return [...columns, ...extras].map(column => catalogItem(column, metricKeys))
}

function catalogItem(column, metricKeys) {
  const { dataField, text } = column
  const hasText = typeof text === 'string' ? text.trim().length > 0 : Boolean(text) && typeof text !== 'function'
  const fallback = startCase(dataField)

  return {
    key: dataField,
    label: hasText ? text : fallback,
    searchText: typeof text === 'string' && text.trim() ? text : fallback,
    isField: metricKeys.has(dataField),
    configurable: isColumnConfigurable(column),
    alwaysPin: isAlwaysPinned(column),
    allowReorder: canReorder(column),
  }
}
